// Module
var code = `<div class="trio-color-gradient">
    {{#.value}}
        <div class="trio-color-gradient-line" style="background: linear-gradient(to right, {{.Color1}}, {{.Color2}}, {{.Color3}});"></div>
    {{/}}
</div>`;
// Exports
export default code;